import classNames from "classnames";
import styles from "./index.module.scss";

export const Button = ({
  children,
  color = "secondary",
  className,
  size = "sm",
  disabled,
  innerRef,
  href,
  onClick,
  preventDefault,
  stopPropagation,
  ...rest
}) => {
  const buttonColorClass = `btn-${color}`;
  const buttonDisabledClass = `${disabled ? "disabled" : ""}`;
  const buttonSizeClass = `btn-${size}`;

  const handleOnClick = (event) => {
    preventDefault && event?.preventDefault();
    stopPropagation && event.stopPropagation();
    if (href) {
      window.open(href, "_blank");
    } else {
      onClick?.(event);
    }
  };

  return (
    <button
      ref={innerRef}
      className={classNames(
        styles[buttonColorClass],
        styles.btn,
        buttonSizeClass,
        buttonDisabledClass,
        className,
      )}
      disabled={disabled}
      onClick={handleOnClick}
      {...rest}
    >
      {children}
    </button>
  );
};
